import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DestinationSearch from "../components/destinations/DestinationSearch";
import DestinationCard from "../components/destinations/DestinationCard";

const Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDestinations = async () => {
      const querySnapshot = await getDocs(collection(db, "destinations"));
      const destinationsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDestinations(destinationsData);
      setFilteredDestinations(destinationsData);
    };
    fetchDestinations();
  }, []);

  const handleSearch = (searchCriteria) => {
    const filtered = destinations.filter((destination) => {
      return (
        (searchCriteria.name === "" ||
          destination.name
            .toLowerCase()
            .includes(searchCriteria.name.toLowerCase())) &&
        (searchCriteria.city === "" ||
          destination.city === searchCriteria.city) &&
        (searchCriteria.country === "" ||
          destination.country === searchCriteria.country) &&
        (searchCriteria.experience === "" ||
          destination.experiences.includes(searchCriteria.experience)) &&
        (searchCriteria.bestSeason === "" ||
          destination.bestSeason === searchCriteria.bestSeason)
      );
    });
    setFilteredDestinations(filtered);
  };

  const handleClear = () => {
    setFilteredDestinations(destinations); // Reset to show all destinations
  };

  return (
    <div className="destinations-home">
      <Typography variant="h4" gutterBottom>
        Destinations
      </Typography>

      <DestinationSearch
        destinations={destinations}
        onSearch={handleSearch}
        onClear={handleClear}
      />

      <div className="destinations-list">
        {filteredDestinations.map((destination) => (
          <DestinationCard key={destination.id} data={destination} />
        ))}
      </div>
    </div>
  );
};

export default Destinations;
